import React from 'react';
import './style.scss';
import clsx from 'clsx';
import NftRankLine from '../../../../../general/nft/rankLine';
import { WSPlayer } from 'shared';

interface Props {
  data: WSPlayer;
  align: 'right' | 'left';
}

const BattleActionNftInfo = ({ data, align }: Props) => (
  <div
    className={clsx('fight-action-nft-info', `fight-action-nft-info-${align}`)}
  >
    <p className='caption'>Name:</p>
    <h4 className='fight-action-nft-info-value body-2 no-wrap'>{data.name}</h4>
    <p className='caption'>Rank:</p>
    <NftRankLine rank={data.rank} />
  </div>
);

export default BattleActionNftInfo;
